export default function LoadAssigned({ 
    exercise,
    set,
    isSkipped,
    isCompleted,
    showLabel = true
}) {

    if (isSkipped === true || isCompleted === true) {
        return null
    }

    if (exercise.exerciseType === 'bodyweight') {
        return null
    }

    return (
        <div className='space-y-2'>
            {showLabel && (
                <div className='text-xs text-center text-gray-600'>
                    Target Load
                </div>
            )}

            {set.recommendationData.weightRecommendationLoaded === false && (
                <div className="w-20 h-20 bg-gray-200 rounded-xl animate-pulse" />
            )}

            {set.recommendationData.weightRecommendationLoaded === true && (
                <div className='w-20 h-20 rounded-xl flex items-center justify-center border border-gray-400 bg-white relative'>
                    <p className="text-4xl text-center text-gray-900 mb-3">
                        {set.recommendationData.labelWeightRecommendationRounded || 0}
                    </p>

                    <div className='absolute bottom-2 left-0 w-full text-center text-xs text-gray-800'>
                        lbs
                    </div>
                </div>
            )}
        </div>
    )
}